$(function(){

	objectFitImages(); 
	/* スクロール */
  $('a[href^="#"]').not('.no_hash').click(function(){
    var speed = 500;
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top;
    $("html, body").animate({scrollTop:position}, speed, "swing");
    return false;
  });	


	var currentScroll;
	$('#menu_trigger').click(function() {
	    $('#open_navi').fadeIn();
	    $('#open_navi').addClass("is-open");
		//currentScroll = $(window).scrollTop();
	//	$('body').addClass('active');
	//	$('body').css({
	  //		top: -1 * currentScroll
		//});
	})
	$('#menu_close').click(function() {
	    $('#open_navi').fadeOut();
		$('#open_navi').removeClass("is-open");
		$('body').removeClass('active');
	//	window.scrollTo( 0 , currentScroll );
	})

	$(".acdn_head").on("click", function() {
		$(this).next().slideToggle();
		$(this).toggleClass("is-open");
	});	
	
	if (window.matchMedia( "(max-width: 749px)" ).matches) {
		$('.footer_menu_parent').on('click', function(){
			$(this).toggleClass('is-open');
			$(this).next('.footer_menu_child').slideToggle();
			$(this).next().toggleClass('is-open');
			return false;
		});  
	}		


	//パララックス
	$(window).scroll(function() {
		var elem = $('.move');
		elem.each(function () {
			var elemOffset = $(this).offset().top;
			var scrollPos = $(window).scrollTop();
			var wh = $(window).height();

			if(scrollPos > elemOffset - wh + (wh / 6) ){
			  $(this).addClass("active");
			}else{
				$(this).removeClass("active");
			}
		});

	});

});

